import { $userLanguage, $userRefInfo } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { AppButton } from '@/shared/ui/button'
import ButtonWrapper from '@/shared/ui/buttonWrapper'
import { Icon } from '@/shared/ui/icon'
import { useStyles } from '@/widgets/referral/styles'
import { Skeleton } from '@mui/material'
import WebApp from '@twa-dev/sdk'
import { useUnit } from 'effector-react'
import { useCallback } from 'react'

export const SocialSkeleton = () => {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const refInfo = useUnit($userRefInfo)
  const title = lang[userLang].tabs.friends
  const texts = lang[userLang].pages.friends
  const units = lang[userLang].pages.units
  const btnTexts = lang[userLang].pages.btnTexts
  const handleGoToChat = useCallback(() => {
    if (userLang === 'en') {
      return WebApp.openTelegramLink('https://t.me/gamedchaten')
    }
    return WebApp.openTelegramLink('https://t.me/gamedchatcis')
  }, [userLang])
  const firstLevel: number = refInfo?.level_1_ref_ratio ? refInfo?.level_1_ref_ratio * 100 : 10
  const secondLevel: number = refInfo?.level_2_ref_ratio ? refInfo?.level_2_ref_ratio * 100 : 5
  return (
    <div className={classes.root}>
      <div className={classes.titleText}>
        <h1>{title}</h1>
        {texts.header({ firstLevel, secondLevel })}
      </div>
      <div className={classes.infoContainer}>
        <Skeleton
          variant="rounded"
          width={'100%'}
          height={250.3}
        />
        <div className={classes.friendsInfo}>
          <Skeleton
            variant="rounded"
            height={93.3}
            className={classes.friendsInfoItem}
          />
          <Skeleton
            variant="rounded"
            height={93.3}
            className={classes.friendsInfoItem}
          />
        </div>
        <p className={classes.ambassador}>{texts.ambassadorInfo(handleGoToChat)}</p>
        <p
          className={classes.friendTitle}
          style={{ textAlign: 'left', display: 'block', width: '100%' }}
        >
          {texts.yourFriends}
        </p>
        <div
          className={classes.friendsHeader}
          style={{ width: '100%' }}
        >
          <p>#</p>
          <p>{texts.user}</p>
          <p>{units.value}</p>
        </div>
        <div style={{ width: '100%' }}>
          {new Array(5).fill(null).map((_, index) => (
            <Skeleton
              key={index}
              variant="rounded"
              height={58.39}
              className={classes.user}
            />
          ))}
        </div>
      </div>
      <ButtonWrapper
        style={{
          paddingLeft: '5%',
          paddingRight: '5%',
          flexDirection: 'row',
          justifyContent: 'center',
          marginBottom: '10vh',
        }}
        startColor="#FFFFFF00"
        endColor="#00000000"
      >
        <AppButton
          size="large"
          fullWidth
          disabled={true}
          className={classes.inviteBtn}
        >
          {btnTexts.invite}
        </AppButton>
        <AppButton
          size="large"
          disabled={true}
          variant="secondary"
          className={classes.copyBtn}
        >
          <Icon view="copy" />
        </AppButton>
      </ButtonWrapper>
    </div>
  )
}
